export const Bill = {
  CorpSetting: {
    Type: {
      epay: 1,
      cash: 10,
    },
    Status: {
      registered: 10, // 등록, 확인중
      activated: 20, // 사용가능
      suspended: 30, // 종료중 - 취소만 가능, 학부모로부터 새로운 결제를 받을 수 없음, 청구서 생성 금지
      stopped: 40, // 종료됨 - 취소 포함 모든 van 요청 금지, 청구서 생성 금지
      deleted: 50, // 삭제 - 안보임
    },
  },
  Group: {
    Status: {
      created: 1,
      sent: 2,
      deleted: 3,
    },
  },
  Account: {
    Method: {
      use: 1,
      carrieOverMoney: 2, // 이월금
      advancedPayment: 3, // 선납금
      deductionWhileBillIssuing: 3, // 청구서 발행중 차감
      restorationWhileBillCanceling: 4, // 청구서 취소중 복원
      useToPay: 5, // 결제하는데 사용
      errorCorrection: 6, // 오류수정
    },
  },
  CashBill: {
    Kind: {
      incomeTaxDeduction: 1,
      evidenceOfExpenditure: 2,
    },
    Status: {
      created: 1,
      errorOnIssuing: 299,
      issued: 300,
      successful: 304,
      failed: 305,
      canceled: 400,
    },
  },
  Item: {
    Kind: {
      tuition: 1, // 수강료
      material: 3, // 재료비
      meal: 4, // 급식비
      clothing: 5, // 피복비
      exam: 6, // 모의고사비
      textbook: 19, // 교재비
      etc: 20, // 기타
      // 기숙사비 뺐음
    },
  },
  Preset: {
    Type: {
      normal: 1, // 일반항목
      discount: 2, // 할인항목
    },
  },
  Status: {
    created: 1,
    sent: 2,
    deleted: 3,
    canceled: 4,
    closed: 5,
    complete: 6, // 완납
  },
  Payment: {
    Method: {
      onlineCard: 1,
      wireTransfer: 2,
      offlineCard: 3,
      offlineCash: 4,
      accountBalance: 5, // 원비통장 차감
      localCurrency: 6,
      terminalCard: 7,

      etcPaymentMethod: 9, // 기타 방법 사용

      onlineCardCancel: 21,
      wireTransferRefund: 22,
      offlineCardCancel: 23,
      offlineCashRefund: 24,
      accountBalanceRefund: 25, // 원비통장 환원
      localCurrencyCancel: 26,
      terminalCardCancel: 27,

      etcPaymentMethodRefund: 29, // 기타 방법 환원

      memo: 40,
    },
    OnlineCardSubMethod: {
      kkmomModuda: 1,
      anotherModuda: 2,
      anotherLinkPay: 3,
    },
    PaymentCompCode: ['SHINHAN', 'KBPAY', 'HYUNDAI', 'HANA', 'KKP2'] as const,
    LocalGiftCardBrand: [
      'gyeonggi',
      'gwangmyeon',
      'incheon',
      'cheonan',
      'cheongju',
      'gangneung',
      'ulsan',
      'yangsan',
      'gimpo',
      'gyeongju',
      'miryang',
      'sangju',
      'yeomin',
      'chungju',
      'hoengseong',
      'samcheok',
      'inje',
      'gyeongsan',
      'taebaek',
      'uljin',
      'gimcheon',
      'jincheon',
      'etckb',
    ] as const,

    Quota: [0, 2, 3, 4, 5, 6] as const,

    // 현금영수증과 관련된 현금성 수납/환불 방법
    MethodWithCash: ['wireTransfer', 'offlineCash', 'wireTransferRefund', 'offlineCashRefund'],
    OnlineStatus: {
      started: 0,
      success: 10,
      sslComError: 40,
      // linkPay이후 엄밀하게 새로운 세트 추가
    },
    TerminalStatus: {
      started: 0, // 다이얼로그 띄움
      connected: 10, // 소켓 오픈
      processing: 15, // 사용자가 버튼을 눌러 단말기에 요청 들어감
      processed: 20, // 단말기에서 응답 옴
      connectionError: 40,
    },
    // 모든 newPayStatus는 서버가 항상 알고 있게 한다.
    // client가 먼저 알면 api서버에게 보고함
    // pay서버가 먼저 알면 db에 업데이트
    NewPayStatus: {
      started: 0, // 0 링크 누름
      success: 10, // 10 success
      transactionError: 99, // 사용자가 보는 상태

      linkIssued: 31, // 31 링크 받아옴
      linkIssueFailed: 32, // 32 링크 못받아옴
      linkOpened: 33, // 33 간편결제앱 열었음
      linkOpenFailed: 34, // 34 앱에서 링크 열지 못함
      linkPayStoppedManually: 35, // 35 간편결제앱 열어놓고 수동 취소

      paymentKeyIssued: 41, // 41 paymentKey 얻어옴
      paymentKeyIssueFailed: 42, // 42 paymentKey 얻어오기 실패

      approvalFailed: 51, // 51 승인 못받음(오류)
      approvalNetworkError: 52, // 52 승인 못받음(네트워크오류)

      cancelFailed: 61, // 61 취소 실패(오류)
      cancelNetworkError: 62, // 62 취소 실패(네트워크 오류)
    },
    CardOwner: ['a', 'b', 'c', 'd'],
    Van: {
      niceEpay: 1,
      kisTerminal: 2,
    },
  },
  Notification: {
    BillSent: {
      MessageType: {
        default: 0,
        reminder: 1,
        update: 2, // 수정발행
      },
    },
    Method: {
      none: 0,
      push: 1,
      pushOrSms: 2, // 기존의 '앱 알림 + 미가입 학부모에게는 문자'
      pushAndSms: 3, // 추가되는 '앱 알림 + 모두에게 문자'
    },
    NewMethod: {
      push: 1,
      simpleAlimTalk: 2,
      payableAlimTalk: 3,
    },
    Target: {
      none: 0,
      nonMember: 1,
      all: 2,
    },
  },
  Template: {
    IssueStrategy: {
      manual: 1,
      autoIndividualByDay: 2,
      // autoGroupByDay: 3,
      autoIndividualByCount: 4,
      // autoGroupByCount: 5,
    },
  },
  Stats: {
    maxRecentMonths: 13,
  },
};
